import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  background-image: url(', ');\n  background-position-x: ', ';\n  background-position-y: ', ';\n  background-size: cover;\n  background-repeat: none;\n  min-height: ', ';\n\n  @media (max-width: ', ') {\n    background-image: url(', ');\n  }\n'], ['\n  background-image: url(', ');\n  background-position-x: ', ';\n  background-position-y: ', ';\n  background-size: cover;\n  background-repeat: none;\n  min-height: ', ';\n\n  @media (max-width: ', ') {\n    background-image: url(', ');\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  margin: 0 auto;\n  max-width: 600px;\n  padding: ', ';\n  min-height: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: ', ') {\n    ', '\n  }\n'], ['\n  background-color: #fff;\n  margin: 0 auto;\n  max-width: 600px;\n  padding: ', ';\n  min-height: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: ', ') {\n    ', '\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin: 10px 15px;\n\n  @media (max-width: ', ') {\n    ', '\n  }\n\n  form {\n    input,\n    select {\n      padding: 10px;\n\n      @media (max-width: ', ') {\n        padding: 8px;\n      }\n    }\n  }\n'], ['\n  margin: 10px 15px;\n\n  @media (max-width: ', ') {\n    ', '\n  }\n\n  form {\n    input,\n    select {\n      padding: 10px;\n\n      @media (max-width: ', ') {\n        padding: 8px;\n      }\n    }\n  }\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject, function (props) {
  return props.bgImage;
}, function (props) {
  return props.bgPosX;
}, function (props) {
  return props.bgPosY;
}, function (_ref) {
  var isModal = _ref.isModal;
  return isModal ? '561px' : 'auto';
}, function (props) {
  return props.theme.mobileWidth;
}, function (props) {
  return props.bgImageMobile;
});

export var StyledContainer = styled.div(_templateObject2, function (_ref2) {
  var isModal = _ref2.isModal;
  return isModal ? '0' : '3em 0';
}, function (props) {
  return props.theme.mobileWidth;
}, function (_ref3) {
  var isModal = _ref3.isModal;
  return isModal && '\n      background-color: unset;\n    ';
});

export var StyledFormWrapper = styled.div(_templateObject3, function (props) {
  return props.theme.mobileWidth;
}, function (_ref4) {
  var isModal = _ref4.isModal;
  return isModal && '\n      background-color: #fff;\n      margin: 0px 15px;\n      padding: 20px;\n    ';
}, function (props) {
  return props.theme.mobileWidth;
});